<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :overlay="false"
    min-width="500"
    max-width="700px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{}">
      <!-- v-on="on" -->
      <v-btn small text :loading="isloading" @dblclick="OpenDialog">
        <slot>Sales</slot>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        Arrived Details
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- {{ item }} -->
        <base-table :header="header" :items="list">
          <template #[`coll.Info`]="{ row }">
            <!-- {{ row.code }} -->
            <tranView
              :AllowEdit="false"
              :key="row.code"
              :Order="row"
            ></tranView>
          </template>
        </base-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    item: [Object],
  },
  components: {
    // OnTheWay: () => import("@/components/HQ/TheWay/items/BulkInventory"),
    tranView: () => import("@/components/HQ/TheWay/items/ariveDetails.vue"),
  },
  data() {
    return {
      SalesRepo: "/Reports/sales/view",
      dialog: false,
      isloading: false,
      list: [],
      header: [
        { title: "Date", value: "Date" },
        { title: "Code", value: "code" },
        { title: "Details", value: "DetailsOrder" },
        { title: "Info", value: "info" },
      ],
    };
  },
  methods: {
    OpenDialog() {
      this.isloading = true;
      this.GetReq()
        .then(val => {
          this.isloading = false;
          this.dialog = true;
          //   console.log(val);
          this.list = val.data;
        })
        .catch(err => {
          this.isloading = false;
          console.log(err);
        });
    },
    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.SalesRepo,
        query: {
          OrderCode: this.item.Details,
          Ref: this.item.Ref,
        },
      });
    },
  },
};
</script>
